export default __webpack_public_path__ + "static/media/realestateicon.79d8c7af.svg";